import { forwardRef, type HTMLAttributes } from 'react';

import {
  ProgressBar,
  ProgressBarIndicator,
  type ProgressBarVariant,
} from '../../atoms/ProgressBar';
import { cn } from '../../utils';

interface AutoneProgressBarProps
  extends ProgressBarVariant,
    HTMLAttributes<HTMLDivElement> {
  max: number;
  value: number;
}

export const AutoneProgressBar = forwardRef<
  HTMLDivElement,
  AutoneProgressBarProps
>(({ className, variant, max, value, children, ...props }, ref) => {
  const progressBarValue = (value / max) * 100;

  return (
    <ProgressBar
      className={cn('relative group/progress-bar', className)}
      variant={variant}
      ref={ref}
      {...props}
    >
      <ProgressBarIndicator
        variant={variant}
        style={{ width: `${progressBarValue}%` }}
      />
      {children}
    </ProgressBar>
  );
});

AutoneProgressBar.displayName = 'AutoneProgressBar';

export const AutoneProgressBarValue = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <p
      className={cn(
        'absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 transition-colors duration-500',
        'text-xs font-light',
        'px-1 py-0.5 rounded-sm border border-border text-muted-foreground shadow-sm backdrop-blur-sm',
        'bg-white/80 group-hover/progress-bar:bg-white/95',
        className,
      )}
      ref={ref}
      {...props}
    >
      {children}
    </p>
  );
});

AutoneProgressBarValue.displayName = 'AutoneProgressBarValue';
